module.exports = __webpack_public_path__ + "static/media/thea.632b703d.png";